if (!customElements.get("m-countdown-timer")) {
  class MCountdownTimer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const now = Date.now();
      const evergreenDays = Number(this.dataset.evergreenDays || 0);
      let endTime = 0;

      if (evergreenDays > 0) {
        const storageKey = this.dataset.storageKey || "getrich_evergreen_countdown";
        const duration = evergreenDays * 24 * 60 * 60 * 1000;

        try {
          const storedDeadline = Number(window.localStorage.getItem(storageKey));

          if (Number.isFinite(storedDeadline) && storedDeadline > now) {
            endTime = storedDeadline;
          } else {
            endTime = now + duration;
            window.localStorage.setItem(storageKey, String(endTime));
          }
        } catch (error) {
          endTime = now + duration;
        }
      } else {
        const time = this.dataset.time || "";
        endTime = Date.parse(time.split(" ").join("T"));
      }

      if (endTime) {
        new CountdownTimer(this, now, endTime);

        if (endTime > now) {
          this.classList.remove("hidden");
          this.classList.remove("m:hidden");
        }
      }
    }
  }

  customElements.define("m-countdown-timer", MCountdownTimer);
}
